var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiRrListCheck = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#" + _uid + "fi-rr-list-check_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2933",
    d: "M2.667 4a2 2 0 0 1-1.415-.586l-1.03-.916a.667.667 0 0 1 .889-.996l1.056.943a.667.667 0 0 0 .971.026L5.541.184a.667.667 0 0 1 .918.965L4.067 3.425a1.98 1.98 0 0 1-1.4.575M16 2.667A.667.667 0 0 0 15.333 2H8.667a.667.667 0 0 0 0 1.333h6.666A.667.667 0 0 0 16 2.667M4.067 8.759l2.392-2.276a.667.667 0 1 0-.918-.966l-2.4 2.288a.68.68 0 0 1-.943 0l-1.06-1.057a.667.667 0 0 0-.943.943l1.057 1.056a2 2 0 0 0 2.817.012zM16 8a.667.667 0 0 0-.667-.667H8.667a.667.667 0 0 0 0 1.334h6.666A.667.667 0 0 0 16 8M4.067 14.092l2.39-2.276a.666.666 0 1 0-.919-.965l-2.4 2.287a.667.667 0 0 1-.97-.027L1.11 12.17a.667.667 0 1 0-.888.996l1.029.916a2 2 0 0 0 2.817.011zM16 13.333a.667.667 0 0 0-.667-.666H8.667a.667.667 0 1 0 0 1.333h6.666a.667.667 0 0 0 .667-.667"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "fi-rr-list-check_svg__a"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export { SvgFiRrListCheck as ReactComponent };
export default __webpack_public_path__ + "ea7fdb721867ebdac6e6eab4978aa974.svg";